import { render, staticRenderFns } from "./SearchDropdown.vue?vue&type=template&id=2330496c&scoped=true"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"
import style0 from "./SearchDropdown.vue?vue&type=style&index=0&id=2330496c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330496c",
  null
  
)

export default component.exports